module.exports = __webpack_public_path__ + "static/media/xls.43a3aade.svg";